<template>
  <div class="form-info">
    <div class="grid-row">
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('company_name')}} *</label>
          <Input 
            :type="'text'" 
            :required="true" 
            :uppercase="true"
            ref="tnomc" 
            :maxlength="25"
            @typing="vSetStore('tnomc', $event)" 
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('currency')}} *</label>
            <Select 
              :placeholder="$_('your_choice')"
              :itemoption="['TCDEV', 'TLIB_DEV']"
              :data="currency"
              :required="true"
              ref="tcdev"
              @select-change="vSetStore('tcdev', $event.item)"
            />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('language')}} *</label>
          <Select 
            :placeholder="$_('your_choice')"
            :itemoption="['TCLANG', 'TLIB_LANG']"
            :data="lang"
            :required="true"
            ref="tclang"
            @select-change="vSetStore('tclang', $event.item)"
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('siret')}}</label>
          <Input 
            :type="'text'" 
            ref="tsiret" 
            :maxlength="17"
            @typing="vSetStore('tsiret', $event)"
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('tva_number')}}</label>
          <Input 
            :type="'text'" 
            ref="ttvacee" 
            :maxlength="17"
            @typing="vSetStore('ttvacee', $event)"
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('website')}}</label>
          <Input 
            :type="'text'" 
            :uppercase="true" 
            ref="tweb" 
            @typing="vSetStore('tweb', $event)" 
            :maxlength="60"
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('division')}} *</label>
          <Select 
            :placeholder="$_('your_choice')"
            :itemoption="['TCDIV', 'TLIB_DIV']"
            :data="division"
            ref="tcdiv"
            :required="true"
            @select-change="vLoadSousDivision($event)"
          />
        </div>
      </div>
      <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
        <div class="form-field no-margin">
          <label>{{$_('sub_division')}}</label>
          <Select 
            :placeholder="$_('your_choice')"
            :itemoption="['TCSDIV', 'TLIB_SDIV']"
            :data="sub_division"
            ref="tcsdiv"
            :resetselect="reset_sub_division"
            @select-change="vSetStore('tcsdiv', $event.item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Input from '@/common/components/widget/Input/Input'
import Select from '@/common/components/widget/Select'

import generalService from '@/modules/defaut/services/generalService'
import customerService from '@/modules/client/services/customerService'

export default {
  data() {
    return {
      currency: Array(),
      lang: Array(),
      division: Array(),
      sub_division: Array(),
      reset_sub_division: false,
    }
  },
  components: {
    Input,
    Select
  },
  created() {
    generalService.getDevise().then(res => {
      this.currency = res.data.DS_O.OUT;      
    });
    customerService.getLang().then(res => {
      this.lang = res.data.DS_O.OUT;      
    });
    customerService.getDivision().then(res => {
      this.division = res.data.DS_O.OUT;      
    });
  },
  methods: {
    vSetStore(key, value) {
      this.$store.dispatch('echantillon/SET_HEADER', {key, value: value.toUpperCase()});
    },
    vLoadSousDivision(event) {
      
      this.vSetStore('tcdiv', event.item);

      this.reset_sub_division = true;

      customerService.getSousDivision(event.item).then(res => {
        this.sub_division = res.data.DS_O.OUT;      
        this.reset_sub_division = false;
      });

    },
  }
}
</script>

<style scoped>
.form-info {
  padding: 15px;
  border: solid 1px #e1e1e1;
  border-radius: 8px;
}
@media screen and (max-width: 800px) {
  .form-info {
    padding: 0px
  }
}
</style>